export default __webpack_public_path__ + "static/portrait4-f91a9195c251369fc557e8ae305e36b0.jpg";